import * as React from 'react'
import Head from 'next/head'
import { PricingInfo } from '../components/PricingPage/PricingInfo'
import { PricingScheduleService } from '../components/PricingPage/PricingScheduleService'
import Layout from '../components/Layout'
import { AboutPageTitleSection } from '../components/AboutPageTitleSection'

import image from '../../public/img/nubrakes-brake-repair-header.jpg'
import secondSectionImage from '../../public/img/brake-rotor-colored.png'

const PricingPage: React.FC = () => {
  return (
    <Layout title={`Brake Repair Pricing - NuBrakes Mobile Brake Repair`}>
      <Head>
        <meta
          name="description"
          content="Need new brake pads, rotors or calipers? Let our brake experts provide you with a free, no-obligation brake repair quote!"
        />
      </Head>
      <AboutPageTitleSection title={`Brake Repair Service Pricing`} bgImageOverride={image.src} />
      <PricingInfo
        image={secondSectionImage}
        title={`Contact Us For A Quote.`}
        buttonText={`Get A Free Brake Repair Estimate`}
        orangeTitle={`Mobile Brake Service Starting At $119`}
      />
      <PricingScheduleService title={`Schedule your mobile brake repair in minutes.`} />
    </Layout>
  )
}

export default PricingPage
